import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { PermissionService } from '../services/permission.service';

@Injectable({ providedIn: 'root' })
export class LandingRedirectGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router, private perms: PermissionService) {}

  canActivate(): boolean | UrlTree {
    if (this.auth.isLoggedIn()) {
      this.perms.ensureFresh();
      // Home page for authenticated users
      return this.router.createUrlTree(['/ppk-studio']);
    }
    return true;
  }
}
